function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import SmartCollection from './smart_collection';
import DiscourseVote from './discourse_vote'; // @namespace Model

var DiscourseVotes = /*#__PURE__*/function (_SmartCollection) {
  _inheritsLoose(DiscourseVotes, _SmartCollection);

  function DiscourseVotes() {
    return _SmartCollection.apply(this, arguments) || this;
  }

  var _proto = DiscourseVotes.prototype;
  /**
   * Discourse vote is a singleton resource. For every result, there is only one
   * vote model associated with it. Make the collection aware of this and
   * prevent two vote models with the same `result_id` from existing.
   */

  _proto.modelId = function modelId(attrs) {
    return attrs.result_id;
  };

  _proto.initialize = function initialize(models, options) {
    if (models === void 0) {
      models = [];
    }

    if (options === void 0) {
      options = {};
    } // Track parent


    this.poll = options.poll;
  };

  _proto.url = function url() {
    var participantKey = this.poll && this.poll.get('participant_key');

    if (participantKey && this.poll.type() === 'discourse') {
      return "/api/participant/discourses/" + participantKey + "/votes";
    } else {
      return '';
    }
  };

  _createClass(DiscourseVotes, [{
    key: "model",
    get: function get() {
      return DiscourseVote;
    }
  }]);

  return DiscourseVotes;
}(SmartCollection);

export { DiscourseVotes as default };